module.exports = __webpack_public_path__ + "static/media/RP-75.1ae69900.pdf";